import { render, staticRenderFns } from "./SupplierAdvert.vue?vue&type=template&id=51b32d6c&"
import script from "./SupplierAdvert.vue?vue&type=script&lang=js&"
export * from "./SupplierAdvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports